// DeletePostDialog.tsx — shared delete-confirm dialog for PostCard + HeroPostCard.
import styled from 'styled-components';
import { Dialog, Button } from '@/ui';

export interface DeletePostDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DialogBody = styled.p`
  margin: 0 0 16px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const DialogFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export function DeletePostDialog({ open, onCancel, onConfirm }: DeletePostDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} title="Delete this post?">
      <DialogBody>
        People will still be able to see it, but no one can interact with it anymore.
      </DialogBody>
      <DialogFooter>
        <Button type="button" variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
